export const FETCH_GENRES_REQUEST = 'genres/FETCH_REQUEST';
export const FETCH_GENRES_SUCCESS = 'genres/FETCH_SUCCESS';
export const FETCH_GENRES_FAILURE = 'genres/FETCH_FAILURE';
